import { createApp } from "vue"
import "@/css/tailwind.css"
import Calendar from "@/js/components/Calendar.vue"
import type { CalendarDisplay, CalendarView } from "@/js/types/calendar"
import type { EventDTO } from "@/js/types/generated"

document.querySelectorAll<HTMLElement>(".sno-calendar-events").forEach((mountEl) => {
	const display = (mountEl.dataset.display ?? "calendar") as CalendarDisplay
	const view = (mountEl.dataset.view ?? "month") as CalendarView
	const compact = mountEl.dataset.compact === "true"
	const perPage = Math.max(1, Number.parseInt(mountEl.dataset.perPage ?? "", 10) || 10)
	const categories = (mountEl.dataset.categories ?? "").split(",").filter((slug) => slug !== "")
	const initialEvents = JSON.parse(mountEl.querySelector(".sno-calendar-init")?.textContent ?? "[]") as EventDTO[]

	createApp(Calendar, { display, view, compact, perPage, categories, initialEvents }).mount(mountEl)
})
